import { Component, Input } from '@angular/core';
import { ActivityLocation } from '@curbnturf/entities';
import { IonicModule, ModalController } from '@ionic/angular';
import { RatingPoiComponent } from '../rating-poi/rating-poi.component';

@Component({
  selector: 'curbnturf-rating-poi-page',
  templateUrl: './rating-poi-page.component.html',
  styleUrls: ['./rating-poi-page.component.scss'],
  standalone: true,
  imports: [IonicModule, RatingPoiComponent],
})
export class RatingPoiPageComponent {
  @Input() poi: ActivityLocation;

  constructor(private modalController: ModalController) {}

  async onCloseModal() {
    await this.modalController.dismiss();
  }
}
